import { updateVariantsFromFormatKey } from "core/services/site/fragment";
import { getTask } from "core/services/site/task";
import createPoller from "utils/createPoller";
import getTaskId from "utils/getTaskId";

const createNewFormat = async (
    requestedFormat: string,
    sessionToken: string,
    fragmentID: number,
): Promise<void> => {
    await updateVariantsFromFormatKey(
        sessionToken,
        requestedFormat,
        fragmentID,
    );
    const taskId = await getTaskId(sessionToken, fragmentID);
    if (taskId) {
        let failureCount = 0;
        await createPoller(async () => {
            try {
                const taskInfo = await getTask(sessionToken, taskId);
                if (!taskInfo.value) {
                    return true;
                }
                if (taskInfo.value.processing) {
                    return false;
                }
                const lastTaskResult = taskInfo.value.results.pop();
                if (!lastTaskResult?.result) {
                    throw new Error("last task result showed error");
                }
                return true;
            } catch (error) {
                failureCount += 1;
                if (failureCount > 4) {
                    // Assume this fragment is broken and stop polling
                    return true;
                }
                return false;
            }
        }, [{ iterations: 1000, interval: 2000 }]);
    } else {
        throw new Error("fragment could not be found");
    }
};

export default createNewFormat;
